export default __webpack_public_path__ + "static/media/extend-stay.23cbd216.svg";